 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","7":"vendors~Header~about~acs_result~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotel_rev~9c7419a7","12":"vendors~Header~about~acs_result~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~~05087fad","17":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_reviews_page~hotels~order~order_changing_~b3fd1b5f","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","22":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~order~testim~0329968d","23":"Header~acs_result~alfa_pay~pay_card~sbp~t_pay","25":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~testimonials~tinkoff_iframe","27":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Header~about~header_app","32":"AuthNew~ClientFormContainer","33":"FiltersPanel","34":"Map~YandexMapsSearch","36":"vendors~AuthNew~ClientFormContainer","37":"vendors~Cigarette~tinkoff_iframe","38":"AboutRoomPopup","39":"AndroidIcon","40":"AuthNew","41":"Cigarette","42":"ClientFormContainer","43":"EmptyFiltration","44":"EmptySearch","45":"ExpensiveHotelsPopup","46":"FiltersPanelMobile","47":"FlightFail","48":"FlightsItem","49":"Header","50":"HeaderAuth","51":"IosIcon","52":"Map","53":"MountainsContainer","54":"NoTopHotel","55":"NpsForm","56":"OperatorsStatuses","57":"PriceChart","58":"SeamlessTBankAuth","59":"SearcherEmptyHotel","60":"SimilarPackagesContainer","61":"Subscribe","62":"ToAppgallery","63":"ToRustore","64":"YandexHotelMap","65":"YandexMapCheckout","66":"YandexMapsSearch","91":"sigmaInit","97":"vendors~AboutRoomPopup","98":"vendors~EmptySearch","99":"vendors~HotelNotice","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"e884acc967299dde269c","7":"6463339654eff7cf69bc","12":"ff64a72978fb6309d3bf","17":"3a59c87f75a191c95e37","18":"efe5c6eaca886f9d9049","20":"e74db5b96985b8b1b156","21":"c2b47dddaaa5767926b6","22":"fda01265a342edfc1287","23":"d4384245a2d8edbfc2a9","25":"c442fd83be4cf112ef1f","27":"d76987829218419d2afe","28":"23d0a18b3a5d6f769727","30":"357d318e64e614c3adf0","32":"6b8aba67064028f812a1","33":"4aa073bc1d2c283ba40f","34":"bb8051bcd319e01fa915","36":"6f1cb7091b974ff4a87e","37":"5e7cf3786272a874a0e8","38":"78ce36e0e25bdca27b13","39":"8f38c776d4ba39baaebf","40":"8a0661955e3d94e3716c","41":"9bc5e18b255c82186774","42":"3d4e215c11850c7ef149","43":"baf808118ad378e30cc7","44":"45e081187e6a85492961","45":"adfc903a868255c81080","46":"eb56ab825e4d1d03adfe","47":"833cb6b22bf85c052273","48":"97cec94fd54a19c2407c","49":"1f97678f554401ae5d6b","50":"1f4237dae039a28860d9","51":"3d7b345d3fd6a1c7fd8c","52":"532e8c8832920c5cb869","53":"cad333531c40d9e91ec7","54":"ea1c80ccf5f77528b994","55":"9d95e2b4f4ea82f92bcb","56":"bb97142fe327b97bdd58","57":"a81eefe9cb5251b4269b","58":"54ae9de3a6969cf8c88d","59":"8ae6093049f142221de3","60":"4e08810a3a771f48f1a6","61":"23639346e8170d1a1565","62":"49f85eee2efc9327d736","63":"084df61ca7330201f95a","64":"a5b051f69d02df8ed904","65":"7aa38808fe8edde77cdf","66":"4d493091f82db8f12c0c","91":"ebbd5ae8feabde07a475","97":"5004cdf33873fcb621d7","98":"1e7c41191ca12c060f93","99":"80aba1b3b5cbd086cf29","100":"10be67adf57bada6803d","106":"e8ccd0e0be1792e032e9"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"32":1,"33":1,"34":1,"40":1,"44":1,"45":1,"47":1,"49":1,"50":1,"52":1,"54":1,"56":1,"57":1,"59":1,"64":1,"65":1,"66":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","7":"vendors~Header~about~acs_result~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotel_rev~9c7419a7","12":"vendors~Header~about~acs_result~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~~05087fad","17":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_reviews_page~hotels~order~order_changing_~b3fd1b5f","20":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","22":"vendors~Cigarette~Header~about~client~header_app~modern_desktop_home~modern_mobile_home~order~testim~0329968d","23":"Header~acs_result~alfa_pay~pay_card~sbp~t_pay","25":"vendors~AuthNew~Cigarette~ClientFormContainer~sbp~testimonials~tinkoff_iframe","27":"vendors~AuthNew~Cigarette~ClientFormContainer~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Header~about~header_app","32":"AuthNew~ClientFormContainer","33":"FiltersPanel","34":"Map~YandexMapsSearch","36":"vendors~AuthNew~ClientFormContainer","37":"vendors~Cigarette~tinkoff_iframe","38":"AboutRoomPopup","39":"AndroidIcon","40":"AuthNew","41":"Cigarette","42":"ClientFormContainer","43":"EmptyFiltration","44":"EmptySearch","45":"ExpensiveHotelsPopup","46":"FiltersPanelMobile","47":"FlightFail","48":"FlightsItem","49":"Header","50":"HeaderAuth","51":"IosIcon","52":"Map","53":"MountainsContainer","54":"NoTopHotel","55":"NpsForm","56":"OperatorsStatuses","57":"PriceChart","58":"SeamlessTBankAuth","59":"SearcherEmptyHotel","60":"SimilarPackagesContainer","61":"Subscribe","62":"ToAppgallery","63":"ToRustore","64":"YandexHotelMap","65":"YandexMapCheckout","66":"YandexMapsSearch","91":"sigmaInit","97":"vendors~AboutRoomPopup","98":"vendors~EmptySearch","99":"vendors~HotelNotice","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"0ffaa8b118cefc3ac228","7":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","17":"d41d8cd98f00b204e980","18":"d41d8cd98f00b204e980","20":"d41d8cd98f00b204e980","21":"d41d8cd98f00b204e980","22":"d41d8cd98f00b204e980","23":"d41d8cd98f00b204e980","25":"d41d8cd98f00b204e980","27":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","32":"b61c63c451d3dfcb51e1","33":"bf25ac7aeb6dccbefb83","34":"44173ef29090408cf488","36":"d41d8cd98f00b204e980","37":"d41d8cd98f00b204e980","38":"d41d8cd98f00b204e980","39":"d41d8cd98f00b204e980","40":"c06fe60c4aedeea3460c","41":"d41d8cd98f00b204e980","42":"d41d8cd98f00b204e980","43":"d41d8cd98f00b204e980","44":"7bc690fbfb444b4fb1b5","45":"44a3f21ea8acc536d3ad","46":"d41d8cd98f00b204e980","47":"3d5c7660f989b289df97","48":"d41d8cd98f00b204e980","49":"e7c7cfa52039ad4cf3f0","50":"e2dc08d21432f13fd3cc","51":"d41d8cd98f00b204e980","52":"23b2d199ef07ed3b3d27","53":"d41d8cd98f00b204e980","54":"563237d543522fbcc346","55":"d41d8cd98f00b204e980","56":"a65265f17a8153dfeb55","57":"dcd01e976637fa2df2e8","58":"d41d8cd98f00b204e980","59":"75658e3d18bc8e0d0ddd","60":"d41d8cd98f00b204e980","61":"d41d8cd98f00b204e980","62":"d41d8cd98f00b204e980","63":"d41d8cd98f00b204e980","64":"05caa9d97f0d66d5cb8f","65":"05b56ebd11809d58c1e8","66":"00473b166a1965df28ba","91":"d41d8cd98f00b204e980","97":"d41d8cd98f00b204e980","98":"d41d8cd98f00b204e980","99":"d41d8cd98f00b204e980","100":"d41d8cd98f00b204e980","106":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
